
    const SHARE_TITLE = 'Talk 工控';
    const SHARE_DESC = 'Talk工控 - 买道传感网旗下资讯平台，工控界喜欢搞事情的行业资讯网站。';
    const SHARE_LINK = 'http://m.talkgk.com';
    const SHARE_IMAGE_URL = 'https://img.51mydao.com/1562569805544_LzkFhDiK_Talk_Logo_200-200.jpg';
    const NULL_COVER_IMAGE_URL = 'http://m.talkgk.com/assets/imgs/empty-article.png';
    export default{
        SHARE_TITLE,
        SHARE_DESC,
        SHARE_LINK,
        SHARE_IMAGE_URL,
        NULL_COVER_IMAGE_URL
    }